// Angular
import { Injectable } from '@angular/core';

// Interfaces
import { IIncidentType, INewIncidentType, IUpdatedIncidentType } from '../../interfaces/seacom/incidenttype';

// Services
import { ApiNodeService } from './templates/apinode.service';
import { SeacomApiService } from './seacom-api.service';


@Injectable({
  providedIn: 'root'
})
export class IncidentTypesService extends ApiNodeService<IIncidentType, INewIncidentType, IUpdatedIncidentType> {
  node = 'incidenttypes';

  constructor(public seacomApiService: SeacomApiService) {
    super(seacomApiService);
  }
}
